import { RootState } from '@/store/types';
import { GetterTree } from 'vuex';
import { MailRegistrationState } from './types';

export const getters: GetterTree<MailRegistrationState, RootState> = {}
